import { UUID } from "src/utils/uuid";

export const NAMESPACE = "event";

export type EventID = UUID<typeof NAMESPACE>;
export const toEventID = (str: string) => str as EventID;

export type GameID = UUID<"game">;
export const toGameID = (str: string) => str as GameID;

export type LineupID = UUID<"lineup">;
export const toLineupID = (str: string) => str as LineupID;

export type StreamID = UUID<"stream">;
export const toStreamID = (str: string) => str as StreamID;

export type AssetID = UUID<"asset">;
export const toAssetID = (str: string) => str as AssetID;

export const toHomeAwayOption = (str: HomeAwayOption) => str;

export type EventTypeGame = "game";
export type EventType = EventTypeGame | "practice" | "other";
export type HomeAwayOption = "home" | "away";
export type EventStatus = "scheduled" | "canceled";
export type RSVPStatus = "no_response" | "going" | "not_going";
export type RSVP = {
  eventID: EventID;
  status: RSVPStatus;
  //    attending: TeamMember.TeamMemberUser | TeamMember.Player;
  //    associatedPlayer: TeamMember.Player | undefined;
};

export type Opponent = {
  id?: string;
  name: string;
  shouldImportOpponent: boolean;
};

export enum BatsFieldingPosition {
  PITCHER = "P",
  CATCHER = "C",
  FIRST_BASE = "1B",
  SECOND_BASE = "2B",
  THIRD_BASE = "3B",
  SHORTSTOP = "SS",
  LEFT_FIELD = "LF",
  CENTER_FIELD = "CF",
  RIGHT_FIELD = "RF",
  SHORT_FIELD = "SF",
}

export interface LineupEntry {
  //    player: TeamMember.Player;
  fieldingPosition?: BatsFieldingPosition | null;
}

export type Lineup = {
  id: LineupID;
  // dh: TeamMember.Player | undefined;
  // dhBattingFor: TeamMember.Player | undefined;
  entries: LineupEntry[];
};

export type Location = {
  name?: string;
  placeID?: string;
  coordinates?: {
    latitude: number;
    longitude: number;
  };
  mapsURL?: string;
};

export enum ScheduledEventSubType {
  Scrimmages = "scrimmages",
}

export interface EventTime {
  start: string;
  end: string;
  timezone: string;
  isFullDay?: boolean;
  arrive?: string;
  recurranceRule?: string;
}

export interface Event extends EventTime {
  id: EventID;
  eventType: EventType;
  subType: ScheduledEventSubType[];
  addressParts: string[];
  location: Location;
  status: EventStatus;
  // teamID: Team.TeamID;
  notes?: string;
  title?: string;
  seriesID?: string;
  //organizationID?: Team.OrgID;
  //rsvps: RSVP[];
  opponentTeam?: Opponent;
  homeAway?: HomeAwayOption;
  gameData?: GameData;
  lineupID?: LineupID;
}

//export type ScoredOpponentTeam = Omit<Opponent, "id"> & { id: Team.TeamID };
export interface ScoredEvent extends Event {
  eventType: EventTypeGame;
  //opponentTeam: ScoredOpponentTeam;
  gameData: GameData;
}
export interface DurationOption {
  title: string;
  value: DurationValue;
}
export interface DurationValue {
  minutes?: number;
  hours?: number;
  days?: number;
}

export type GameData = {
  event_id: EventID;
  game_id: GameID;
  game_state: GameState;
  last_time_to_score_ts: string;
  opponent_score: number;
  team_score: number;
  game_period?: number;
  bats_game_state?: BatsGameState;
};

export enum GameState {
  FIRST_HALF = "1st Half",
  SECOND_HALF = "2nd Half",

  FIRST_QUARTER = "1st Quarter",
  SECOND_QUARTER = "2nd Quarter",
  THIRD_QUARTER = "3rd Quarter",
  FOURTH_QUARTER = "4th Quarter",

  FIRST_PERIOD = "1st Period",
  SECOND_PERIOD = "2nd Period",
  THIRD_PERIOD = "3rd Period",

  HALFTIME = "Halftime",
  FIRST_OVERTIME = "Overtime 1",
  SECOND_OVERTIME = "Overtime 2",
  GAME_OVER = "Game Over",
  GAME_COMPLETE = "completed",
  LIVE = "Live",
}

/**
 * Maps a GameChanger game_status ("live" | "new" | "completed") to a GameState.
 * In-progress games (live/new) become LIVE; everything else is treated as finished.
 */
export const liveStatusToGameState = (status?: string): GameState =>
  status === "live" || status === "new" ? GameState.LIVE : GameState.GAME_OVER;

export type BatsGameState = {
  inning: number;
  inningHalf: "top" | "bottom";
};

export type GameStatEdits = Record<string, Record<string, Record<string, Record<string, number>>>>; // teamID -> statType -> playerID -> statName: statValue

export interface VideoStream {
  activeAssetID?: AssetID;
  activeAssetPlaybackUrl?: string;
  audienceType?: "players_family" | "players_family_fans";
  disabled: boolean;
  eventID: EventID;
  isMuted: boolean;
  isPlayable?: boolean;
  liveAt?: string;
  playableAt?: string;
  playbackUrl: string;
  publishUrl: string;
  status: "active" | "ended";
  streamID: StreamID;
  //teamID: Team.TeamID;
  thumbnailUrl?: string;
  //userID?: Account.UserID;
  viewerCount: number;
}
export interface VideoClip {
  id: AssetID;
  eventID: EventID;
  playbackUrl: string;
  thumbnailUrl?: string;
  duration?: number;
  endedAt?: string;
  hidden: boolean;
  cookies: any;
}
export type OrgEventID = UUID<"org-event">;
export const toOrgEventID = (str: string) => str as OrgEventID;

export interface OrgEventTeamInfo {
  eventID: EventID;
  //teamID: Team.TeamID;
  teamName: string;
}

export interface OrgEvent extends EventTime {
  id: OrgEventID;
  //orgID: Team.OrgID;
  status: EventStatus;
  location?: Location;
  addressParts: string[];
  homeTeamInfo?: OrgEventTeamInfo;
  awayTeamInfo?: OrgEventTeamInfo;
}
